import get from 'lodash.get';

export class OrderSearchResultHandler {
  constructor({ salesOrders }) {
    this.salesOrders = salesOrders;
  }

  get hasOrders() {
    const { salesOrders } = this;
    // something is casuing the back
    //  end to return "[" instead of an array.
    //  adding this check until root cause can be determined
    const isString = typeof salesOrders === typeof '';
    return !isString && salesOrders && salesOrders.length > 0;
  }

  get hasOneFulfillmentPlan() {
    const { salesOrders } = this;
    return salesOrders.length === 1 && get(salesOrders, '[0].fulfillmentPlans.length', 0) === 1;
  }

  get firstFulfillmentPlan() {
    const { salesOrders } = this;
    return get(salesOrders, '[0].fulfillmentPlans[0]', {});
  }
}
